import React, { useState } from 'react';
import { useLocation } from "react-router-dom";
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

import { CommonCard } from '../components/content/mdb-custom.component';
import { ResetPasswdForm } from '../components/content/auth-forms.component';
import {
    LoginPageTemplate, PasswordPolicyNote
} from '../components/content/auth-helpers.component';


export const ResetPasswordPage = () => {
    let history = useHistory();
    let location = useLocation();
    const urlParts = location.pathname.split('/');
    const username = urlParts[2];
    const token = urlParts[3];
    if (!token) {
        history.push("/start");
    }
    const [showPolicy, setShowPolicy] = useState(true);

    return (
        <LoginPageTemplate>
            <CommonCard cardTitle='Panel Klienta - Reset hasła'
                        bg={showPolicy ? 'danger' : 'success'}>
                <h4 className='text-start'>Login: <b>{username}</b></h4>
                <ResetPasswdForm username={username} token={token}
                    onResetSuccess={() => { setShowPolicy(false) }} />
                {showPolicy && <PasswordPolicyNote />}
            </CommonCard>
        </LoginPageTemplate>
    )
}
